import { Box } from '@material-ui/core';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';

import { SBase, SEmptyState } from '@setvi/shared/components';

import { useStyles } from './styles';
import { useCartDialog } from './hooks/use-cart-dialog';
import { CartItem, CartSummary } from './components';

interface CartDialogProps {
  onClose: () => void;
}

const CartDialog = ({ onClose }: CartDialogProps) => {
  const classes = useStyles();
  const {
    items,
    removingId,
    handleRemove,
    handleCheckout,
    isCheckingOut,
    totalPages,
    openCustomize
  } = useCartDialog(onClose);

  return (
    <SBase
      width={960}
      style={{ maxHeight: '85vh' }}
      header={{ title: 'Review Cart', onClose }}
      footer={{
        onConfirm: handleCheckout,
        onClose,
        confirmLabel: 'Checkout',
        closeLabel: 'Add more',
        confirmLoading: isCheckingOut,
        disableConfirm: !items.length || isCheckingOut,
        disableClose: isCheckingOut,
        startIcon: <PrintOutlinedIcon />,
        divider: true
      }}>
      {items.length ? (
        <>
          <Box className={classes.grid}>
            {items.map(item => (
              <CartItem
                key={item.resource.ID}
                item={item}
                removing={removingId === item.resource.ID}
                actionsDisabled={removingId !== null || isCheckingOut}
                onEdit={openCustomize}
                onRemove={handleRemove}
              />
            ))}
          </Box>

          <CartSummary count={items.length} totalPages={totalPages} />
        </>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%">
          <SEmptyState
            imageSrc="/images/no-resources.svg"
            title="Your cart is empty"
            subTitle="Add resources to your cart to review them here"
          />
        </Box>
      )}
    </SBase>
  );
};

export { CartDialog };
export { CART_DIALOG_ID } from './constants';
